<template>
  <div class="filter-container">
    <form novalidate @submit.prevent="searchSchool">
      <div class="row">
        <div class="col-md-3">
          <custom-drop-down
            v-model="filter.schoolType"
            :options="schoolTypes"
            :is-bold="true"
            fieldkey="id"
            fieldname="name"
            placeholder="Tipo de Escuela"
            class="height-fixed"
            @input="onChangeSchoolType()"
          />
        </div>
        <div class="col-md-6">
          <custom-drop-down
            v-model="filter.schoolName"
            :options="schools"
            :is-bold="true"
            fieldkey="id"
            fieldname="name"
            placeholder="Nombre de Escuela"
            class="height-fixed"
            :class="{ 'mt-2': isMobile }"
          />
        </div>
        <div class="col-md-1 mt-2 d-flex pt-0 ">
          <div class="custom-control custom-checkbox">
            <input
              id="chkActive"
              v-model="filter.isActive"
              type="checkbox"
              name="chkActive"
              class="custom-control-input"
            />
            <label for="chkActive" class="custom-control-label font bold">
              <span><em class="ic-check" /></span>
              Activas
            </label>
          </div>
        </div>
        <div class="col-md-1">
          <action-button
            type="submit"
            text="Buscar"
            variant="success"
            i="fas fa-search"
            class="px-4"
            :class="{ 'btn-full mt-3': isMobile, 'ml-2': !isMobile }"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';
import schoolManagementApi from '@/modules/operation-school-management/api.js';
import { modulesName } from '@/modules';
import {
  actionTypes,
  getterTypes,
} from '@/modules/operation-school-management/store/types';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.operationSchoolManagementModuleName
);

export default {
  name: 'SchoolSearch',
  components: {
    CustomDropDown,
    ActionButton,
  },
  data() {
    return {
      checkboxText: 'Activas',
    };
  },
  computed: {
    ...mapGetters({
      schools: getterTypes.GET_SCHOOLS,
      schoolTypes: getterTypes.GET_SCHOOL_TYPES,
      filter: getterTypes.GET_FILTER,
      pagination: getterTypes.GET_PAGINATION,
    }),
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    ...mapActions([
      actionTypes.FETCH_RESULT,
      actionTypes.FETCH_SCHOOL_TYPES,
      actionTypes.FETCH_SCHOOLS,
    ]),
    getLocationTypes() {
      schoolManagementApi.getSchoolTypes().then((res) => {
        const data = res.data ? res.data : [];
        this.schoolTypes = data;
      });
    },
    onChangeSchoolType() {
      this.filter.schoolName = null;
      this.getLocationSchools();
    },
    getLocationSchools() {
      this[actionTypes.FETCH_SCHOOLS](this.filter.schoolType?.id);
    },
    searchSchool() {
      const filters = {
        locationSchoolId: this.filter.schoolName?.id ?? '',
        schoolType: this.filter.schoolType,
        isActive: this.filter.isActive,
        schoolName: this.filter.schoolName,
      };
      this.$parent.getSchools(filters);
    },
  },
  async mounted() {
    await this[actionTypes.FETCH_SCHOOL_TYPES]();
    await this.getLocationSchools();
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
  border-radius: 5px;
}

.height-fixed >>> .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px) !important;
}

.btn-full {
  width: 100%;
}

@media only screen and (max-width: 375px) {
  ::v-deep .vs__search {
    font-size: 12px !important;
  }

  ::v-deep .vs__selected {
    font-size: 12px !important;
  }

  ::v-deep .vs__dropdown-menu {
    font-size: 12px !important;
  }
}
</style>
